<li class="item-menu-title" [class.mode-closed]="mode === 1">{{item.name}}</li>